import React, { ReactNode } from "react";
import Header from "./Header";

interface AppLayoutProps {
  children: ReactNode;
  contentClassName?: string;
}

const AppLayout: React.FC<AppLayoutProps> = ({
  children,
  contentClassName,
}) => {
  return (
    <div className="h-screen flex relative">
      <div className="flex-1 flex flex-col bg-[#DEEAF7] overflow-hidden">
        {/* Header is fixed, so we need a spacer */}
        <Header />
        {/* <div className="h-[82px] w-full"></div>{" "} */}
        {/* Spacer to match header height */}
        <main
          className={`flex-1 flex flex-col overflow-y-auto bg-[#DEEAF7] ${
            contentClassName ||
            "px-[18px] md:px-[42px] pt-[16px] md:pt-[30px] pb-[62px]"
          }`}
        >
          {/* Scrollable content */}
          <div className="flex-1">{children}</div>
        </main>
      </div>
    </div>
  );
};

export default AppLayout;
